"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProjectsCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="projects-call-to-action" ref={ref} className="relative flex items-center justify-center bg-[var(--color-dark-background)] py-24 md:py-32 lg:py-40">
      <div className={`container mx-auto max-w-4xl px-6 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--color-foreground-dark)] mb-8">
          Ready to Invest with Complete Transparency?
        </h2>
        <p className="text-lg md:text-xl text-[var(--color-foreground-dark)]/90 mb-10 max-w-2xl mx-auto">
          Access verified land titles, live site cameras, and GPS-stamped progress logs. Trust is not a luxury—it's a guarantee.
        </p>
        <Link to="/DataRoomPage">
          <Button size="lg" className="bg-[var(--color-accent)] text-[var(--color-foreground-accent)] hover:bg-[var(--color-accent-hover)] font-semibold px-8 py-6 text-base md:text-lg rounded-md shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-1 hover:shadow-strong focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-dark-background)]">
            Access the Data Room
          </Button>
        </Link>
      </div>
    </section>;
}